import { assign, Machine } from "xstate";
import { CycleModule } from "../../../../../store/modules/cycle.module";
import { PACycleSaveModel } from "../../../../../store/models/cycle/paCycleSaveDTO";
import { toaster } from "../../../../../utilities/toaster";
const cycleCreationMachine = Machine({
    id: "cycleMachine",
    context: {
        teamId: "",
        paCycleSave: new PACycleSaveModel(),
    },
    initial: "idle",
    states: {
        idle: {
            always: {
                target: "cyclePrimaryInfo",
            },
        },
        cyclePrimaryInfo: {
            on: {
                NEXT_CYCLE_STEP: { target: "gettingTeams" },
            },
            meta: { message: "CYCLE INFO" },
        },
        gettingTeams: {
            invoke: {
                id: "gettingTeams",
                src: (context, event) => {
                    return CycleModule.GetTeamList();
                },
                onDone: { target: "teamsLoaded" },
                onError: { target: "serviceUnavailable" },
            },
        },
        teamsLoaded: {
            on: {
                NEXT_CYCLE_STEP: { target: "checkForSelectedTeam", actions: "assignTeamId" },
                PREV_CYCLE_STEP: { target: "cyclePrimaryInfo" },
            },
            meta: { message: "SELECT RESOURCE" },
        },
        checkForSelectedTeam: {
            always: [
                {
                    target: "gettingWorkFlows",
                    cond: "isTeamIdAvailable",
                },
                {
                    target: "teamsLoaded",
                    actions: "showToasterMessage",
                    cond: "isNotTeamIdAvailable",
                },
            ],
        },
        gettingWorkFlows: {
            invoke: {
                id: "createCycleService",
                src: (context, event) => {
                    return CycleModule.GetWorkFlow(context.teamId);
                },
                onDone: { target: "loadedWorkFlows" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedWorkFlows: {
            on: {
                NEXT_CYCLE_STEP: { target: "gettingConfirmation" },
                PREV_CYCLE_STEP: { target: "teamsLoaded" },
            },
            meta: { message: "SELECT WORKFLOW" },
        },
        gettingConfirmation: {
            always: {
                target: "loadedCofirmation",
            },
        },
        loadedCofirmation: {
            on: {
                PREV_CYCLE_STEP: { target: "loadedWorkFlows" },
                CREATE_CYCLE: { target: "creatingCycle" },
            },
            meta: { message: "LET'S FINISH" },
        },
        creatingCycle: {
            tags: "createCycle",
            invoke: {
                id: "createCycle",
                src: (context, event) => {
                    return CycleModule.CreatePaCycles(event.paCycleSave);
                },
                onDone: { target: "cycleCreated", cond: "" },
                onError: { target: "serviceUnavailable" },
            },
        },
        cycleCreated: {
            type: "final",
        },
        serviceUnavailable: {},
    },
}, {
    guards: {
        isTeamIdAvailable: (context) => {
            return context.teamId !== "" && context.teamId !== null;
        },
        isNotTeamIdAvailable: (context) => {
            return context.teamId === "" || context.teamId === null;
        },
    },
    actions: {
        assignTeamId: assign({
            teamId: (context, event) => event.teamId,
        }),
        showToasterMessage: (context, event) => {
            toaster.ShowError("Please select a Team");
        },
    },
    services: {},
});
export default cycleCreationMachine;
